import React from "react";
import { DateTime } from "luxon";
import DatePicker from "app/components/DatePicker";
import styles from "./styles.module.scss";

type Props = {
  date: DateTime;
  onDateChange: (date: DateTime) => void;
};

export default function SideDatePicker({ date, onDateChange }: Props) {
  return (
    <div className={styles.side_datepicker_container}>
      <DatePicker date={date} setDate={onDateChange} inline />
    </div>
  );
}
